import React from 'react';
import { useNavigate } from 'react-router-dom';
import kondifyLogo from '../assets/Kondify letra negra sin fondo recortada.png';
import './LandingScreen.css';

const TerminosCondicionesScreen = () => {
    const navigate = useNavigate();

    return (
        <div className="landing-container" style={{ background: '#F8FAFC', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* --- NAVBAR SIMPLIFICADO --- */}
            <header className="landing-header" style={{ position: 'sticky', top: 0, background: '#ffffff', borderBottom: '1px solid #E2E8F0', zIndex: 100 }}>
                <div className="landing-nav-content" style={{ display: 'flex', justifyContent: 'between', alignItems: 'center' }}>
                    <div className="landing-brand" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                        <img 
                            src={kondifyLogo} 
                            alt="Kondify" 
                            className="landing-logo-img" 
                        />
                    </div>
                    <button 
                        onClick={() => navigate('/')} 
                        style={{
                            background: '#7E66FC',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '20px',
                            padding: '8px 20px',
                            fontSize: '0.88rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        Volver a la Web
                    </button>
                </div>
            </header>

            {/* --- CONTENIDO PRINCIPAL --- */}
            <main style={{ flex: 1, padding: '64px 24px', maxWidth: '840px', margin: '0 auto', width: '100%' }}>
                <h1 style={{ 
                    fontSize: '2.5rem', 
                    fontWeight: '800', 
                    marginBottom: '8px', 
                    background: 'linear-gradient(135deg, #7E66FC 0%, #F59E0B 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    letterSpacing: '-0.03em'
                }}>
                    Términos y Condiciones
                </h1>
                <p style={{ color: '#475569', fontSize: '1rem', lineHeight: '1.6', marginBottom: '32px' }}>
                    Bienvenido a <strong>Kondify</strong>. Al acceder y utilizar nuestra plataforma SaaS para la administración de condominios, aceptas cumplir con los siguientes términos y condiciones de servicio.
                </p>

                <div style={{ 
                    background: '#ffffff', 
                    border: '1px solid #E2E8F0', 
                    borderRadius: '24px', 
                    padding: '40px', 
                    color: '#334155',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.05), 0 2px 4px -2px rgb(0 0 0 / 0.05)',
                    lineHeight: '1.8', 
                    fontSize: '0.95rem' 
                }}>
                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginBottom: '12px' }}>1. Aceptación de los Términos</h2>
                    <p>Al registrarse y utilizar la plataforma de software como servicio (SaaS) de <strong>Kondify</strong>, usted y el condominio o administración que representa aceptan sujetarse y cumplir con los presentes Términos y Condiciones. Si no está de acuerdo con estos términos, deberá abstenerse de utilizar el servicio.</p>

                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginTop: '32px', marginBottom: '12px' }}>2. Descripción del Servicio</h2>
                    <p>Kondify proporciona una herramienta en la nube para la gestión condominal, que incluye módulos de cobranza automatizada, pasarela de pagos integrada, control de accesos mediante pases QR, reportes financieros y comunicación vecinal. Nos reservamos el derecho de actualizar, modificar o discontinuar características de la plataforma para mejorar el servicio global.</p>

                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginTop: '32px', marginBottom: '12px' }}>3. Uso de la Cuenta y Seguridad</h2>
                    <p>El usuario (Administrador, Comité o Residente) es responsable de mantener la confidencialidad de sus credenciales de acceso y de todas las actividades que ocurran bajo su cuenta. Deberá notificarnos de inmediato cualquier uso no autorizado de sus accesos.</p>

                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginTop: '32px', marginBottom: '12px' }}>4. Licencia de Uso y Propiedad Intelectual</h2>
                    <p>Kondify otorga al cliente una licencia limitada, no exclusiva, no transferible y revocable para utilizar el software de acuerdo con los términos contratados. Todos los derechos de propiedad intelectual del software, código, logotipos y diseños pertenecen exclusivamente a Kondify.</p>

                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginTop: '32px', marginBottom: '12px' }}>5. Condiciones de Pago, Suscripción y Tarifas</h2>
                    <p>Las tarifas por el uso de Kondify se basan en el plan de suscripción seleccionado y el número de casas o unidades del condominio. El pago se cobrará de forma mensual o anual recurrente. En caso de impago, Kondify se reserva el derecho de suspender temporalmente el acceso a la plataforma hasta que la cuenta sea regularizada. Las comisiones por cobro de tarjeta bancaria son procesadas de manera externa por Stripe.</p>

                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginTop: '32px', marginBottom: '12px' }}>6. Limitación de Responsabilidad</h2>
                    <p>Kondify se provee "tal cual" y "según disponibilidad". Aunque nos esforzamos por ofrecer un nivel de servicio de alta disponibilidad y seguridad grado bancario en Google Cloud, no garantizamos que el software esté libre de interrupciones o errores. La responsabilidad total de Kondify ante cualquier reclamación del cliente estará limitada al monto equivalente pagado por el cliente por el servicio en los últimos 12 meses.</p>

                    <h2 style={{ color: '#0F172A', fontSize: '1.25rem', fontWeight: '700', marginTop: '32px', marginBottom: '12px' }}>7. Ley Aplicable y Jurisdicción</h2>
                    <p>Estos Términos se regirán e interpretarán de acuerdo con las leyes vigentes en México. Cualquier controversia derivada de estos términos se someterá a la jurisdicción exclusiva de los tribunales competentes en la ciudad de Guadalajara, Jalisco, renunciando a cualquier otro fuero que pudiere corresponderles.</p>

                    <p style={{ marginTop: '40px', fontSize: '0.85rem', color: '#64748B', borderTop: '1px solid #E2E8F0', paddingTop: '20px' }}>Última actualización: Julio de 2026.</p>
                </div>
            </main>
        </div>
    );
};

export default TerminosCondicionesScreen;
